import { Plus } from "lucide-react";
import { useQuickBook } from "@/lib/quick-book-context";

/**
 * Floating action button for small screens. Sits above the call dock in the
 * bottom-right corner and opens the global Quick Book slide-in (new job + inline
 * customer) — the same panel the top-bar "Quick Book" entry point uses — so the
 * mobile "+" lands on a single consolidated create flow instead of a legacy
 * dropdown of full-page routes.
 */
export function QuickAddFab() {
    const { open } = useQuickBook();
    return (
        <div className="fixed bottom-24 right-4 z-30 lg:hidden">
            <button
                type="button"
                aria-label="Quick book a job"
                onClick={open}
                className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/40 hover:bg-primary/90 transition-all"
            >
                <Plus className="h-6 w-6" />
            </button>
        </div>
    );
}
